import { useEffect } from 'react';
import { useAvatarStore } from '@/stores/avatarStore';

interface UserAvatarProps {
  userId: string;
  username: string;
  /** Size / shape classes, e.g. "h-8 w-8" or "h-10 w-10". Defaults to "h-8 w-8". */
  className?: string;
}

/** Lazy-loads profile picture when mounted; shows initials until loaded or on 404. Caches by userId. */
export function UserAvatar({ userId, username, className = 'h-8 w-8' }: UserAvatarProps) {
  const loadAvatar = useAvatarStore((s) => s.loadAvatar);
  const entry = useAvatarStore((s) => s.cache[userId]);

  useEffect(() => {
    loadAvatar(userId);
  }, [userId, loadAvatar]);

  const initials = username.slice(0, 2).toUpperCase();
  const showImage = entry?.status === 'loaded' && entry.url;

  return (
    <span
      className={`shrink-0 rounded-full overflow-hidden bg-wall-border/50 flex items-center justify-center ${className}`}
    >
      {showImage ? (
        <img src={entry.url} alt="" className="h-full w-full object-cover" />
      ) : (
        <span className="text-xs font-medium text-wall-muted leading-none">{initials}</span>
      )}
    </span>
  );
}
